export enum WorkingHourStatusEnum {
  Approved = "approved",
  NotApproved = "not_approved",
  PaymentPending = "payment_pending",
  Declined = "declined",
}
